import React, { useEffect, useState } from 'react';
import Header from '../../common/components/Header/Header';
import Sidebar from '../../common/components/Sidebar/Sidebar';
import Helmet from 'react-helmet';
import { siteTitle } from '../../../data/SiteConfig';
import Kyc from '../../images/bre/kyc.svg';
import gst from '../../images/bre/gst.svg';
import bankStatment from '../../images/bre/bank statement.svg';
import creditReport from '../../images/bre/credit report.svg';
import Industry from '../../images/bre/industry.svg';
import itr from '../../images/bre/itr.svg';
import foir from '../../images/bre/foir.svg';
import { img, boxContainer, imagecaption } from './BRE.module.css';
import { navigate } from 'gatsby';
const breAreas = [
  {
    name: 'KYC',
    img: Kyc,
    link: '/app/bre/kyc'
  },
  {
    name: 'GST',
    img: gst
  },
  {
    name: 'Bank Statement',
    img: bankStatment
  },
  {
    name: 'Credit Report',
    img: creditReport
  },
  {
    name: 'Industry',
    img: Industry,
    link: '/app/bre/industry'
  },
  {
    name: 'ITR',
    img: itr
  },
  {
    name: 'FOIR',
    img: foir
  }
];
const BREIndex = () => {
  return (
    <div className="w-full">
      <div className="flex w-full">
        <Sidebar />
        <div className="w-full max-h-screen overflow-auto">
          <Header />
          <div className="mx-auto px-6 pt-20 pb-2 md:pt-0 md:pb-0">
            <div className="w-full md:flex md:flex-wrap grid grid-cols-3 gap-6">
              {breAreas.map(each => (
                <div
                  className={`md:px-2 py-2 rounded  relative md:bg-white items-center ${boxContainer} cursor-pointer`}
                  onClick={() => {
                    each?.link && navigate(each.link);
                  }}
                >
                  <div className="w-full md:px-3 py-3 grid gap-y-2 text-center items-center mx-auto">
                    <img src={each.img} className={`${img} mx-auto`} />
                    <p className={`font-roboto mt-2 text-sm ${imagecaption}`}>
                      {each.name}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BREIndex;
